
//import {auth} from "@/scripts/firebase";
//import {updateProfile,User} from "firebase/auth"
import {ref,uploadBytes, getBlob, StorageReference} from "firebase/storage"
import { ModalConfirmProps, NoticeProps } from "@/scripts/datatypes"
import {UserPublicProfile,UserPrivateProfile, UserRelationship} from "../../common-datatypes";
import { Component,Watch ,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
//import { ValidationResult } from 'vee-validate/dist/types/types';
import {toHiragana,toZenKana} from 'jaconv'
import { ValidationFlags } from "vee-validate/dist/types/types";
import TemplateMembers from '@/components/TemplateMembers.vue'
import Confirm from '@/components/ModalConfirm.vue'
import { storage } from "@/scripts/firebase";

/**
 * アップロード画像の内容チェック ファイル形式 サイズ
 * エラー表示
 */


@Component({
  components: {
    TemplateMembers,
    Confirm
  }
})

export default class Profile extends Mixins(Common) {
  isLoadingImage = false
  profileImageNew = ''
//

  isLoading = false
  dialCode = ''
  notice: NoticeProps = {}
  disabledUpdateProfile = true
  userPublicProfile = {} as UserPublicProfile
  userPrivateProfile = {} as UserPrivateProfile
  userRelationship = {} as UserRelationship
  telInputShowFlags = true
  phoneObject = {number: '',valid: false,formatted: ''}

  unlinkLineAccountConfirmProps: ModalConfirmProps = {
    isShow: false,
    isLoading: false,
    title: 'formFields.lineAccount.unlink',
    message: 'editUser.unLinkLineAccountDescription',
  }
	profileImageSrc = ''

  @Watch('userPublicProfile',{deep: true})
  async changeUserPublicProfile(newVal: UserPublicProfile){

    if(newVal.lastNameYomigana){
      newVal.lastNameYomigana = toHiragana(toZenKana(newVal.lastNameYomigana))
      newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    if(newVal.firstNameYomigana){
      newVal.firstNameYomigana = toHiragana(toZenKana(newVal.firstNameYomigana))
      newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

  }

  public inputPhoneNumber(number: string, phoneObject: {number: string; valid: boolean; formatted: string}){
    this.phoneObject = phoneObject
  }

  countryChanged(countryObject: {dialCode: string}){
    console.log(countryObject)
    if(this.changeCountryCount === 0){
      this.$nextTick(() => {
        this.observer.reset()
      })
    }
    this.changeCountryCount ++
  }

  changeCountryCount = 0

  mounted(){
    console.log('mounted')
    this.observer = this.$refs.profileValidationObserver as InstanceType<typeof ValidationObserver>
  }

  @Watch('observer.flags')
  changeObservserFlags(flags: ValidationFlags){
    console.log('changeFlags')
    
    this.disabledUpdateProfile = ! flags.changed
  }

  observer = {} as InstanceType<typeof ValidationObserver>

  updated(){
    console.log('updated')
  }

  async created() {
    console.trace('created')

    this.userPublicProfile = {
      ...this.$store.state.userPublicProfile,
    }

    this.userPrivateProfile = {
      ...this.$store.state.userPrivateProfile
    }

    this.userPrivateProfile.timeZone = this.userPrivateProfile.timeZone ? this.userPrivateProfile.timeZone : this.$defaultTimeZone

    this.userRelationship = {
      ...this.$store.state.userRelationship
    }

     const profileRef = this.$getUserProfileImageRef()
    this.profileImageSrc = await this.getImageURL(profileRef)
  }

  get languages(): string[]{
    if(this.$i18n.availableLocales){
      return this.$i18n.availableLocales
    }
    return [];
  }

  async updateProfile(){
    try{
      this.notice = {
				isShow: false,
      }

      if(this.phoneObject.valid === false || ! await this.observer.validate()){
        if(this.phoneObject.valid === false){
          this.observer.setErrors({
            phoneNumber: this.$t('authentication.errorCode.auth/invalid-phone-number') as string
          })
        }
        return
      }
      
        const updatePublicProfile = {...this.userPublicProfile}
        const updatePrivateProfile = {
          ...this.userPrivateProfile,
          phoneNumber: this.phoneObject.number || ''
        }
        let field: string
      
        for(field in this.userPublicProfile){
          if(this.observer.fields[field] && (this.observer.fields[field].dirty === true || this.observer.fields[field].changed === true)){
            continue
          }
          delete(updatePublicProfile[field as keyof UserPublicProfile])
        }

        for(field in this.userPrivateProfile){
          if(this.observer.fields[field] && (this.observer.fields[field].dirty === true || this.observer.fields[field].changed === true)){
            console.log(field)
            continue
          }
          delete(updatePrivateProfile[field as keyof UserPrivateProfile])
        }
        
        if(Object.keys(updatePublicProfile).length > 0 || Object.keys(updatePrivateProfile).length > 0){

          this.$store.commit("setLoading",true);
          this.isLoading = true

          if(Object.keys(updatePublicProfile).length > 0){
            console.log(updatePublicProfile)
            await this.$updateDoc(this.$getUserPublicProfileDocRef(),updatePublicProfile)
          }

          if(Object.keys(updatePrivateProfile).length > 0){
            console.log('private')
            console.log(updatePrivateProfile)
            await this.$updateDoc(this.$getUserPrivateProfileDocRef(),updatePrivateProfile)
          }

          this.notice = {
            message: this.$t('profile.updated') as string,
            isShow: true,
            type: {'is-success': true}
          }
          this.observer.reset()
        }else{
          this.notice = {
            message: this.$t('profile.noChangedFields') as string,
            isShow: true,
            type: {'is-info': true}
          }
        }
      
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      this.observer.reset()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateProfile = true
    }
  }

  unlinkLineAccountConfirm($event: boolean){
    if($event){
      this.unlinkLineAccount()
    }else{
      this.unlinkLineAccountConfirmProps.isShow = false
    }
  }

  async unlinkLineAccount(){
    try{
      if(this.userPrivateProfile.lineUserId){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        this.unlinkLineAccountConfirmProps.isLoading = true
        const updatePrivateProfile = {
          lineUserId: '',
        }
        await this.$updateDoc(this.$getUserPrivateProfileDocRef(),updatePrivateProfile)

        this.userPrivateProfile.lineUserId = ''
      }
    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.unlinkLineAccountConfirmProps.isLoading = false
      this.unlinkLineAccountConfirmProps.isShow = false
    }
  }

  /**
   * 
   */

  async uploadProfileImage(e: Event){
    const target = e.target as HTMLInputElement
    if(target.files === null){
      return
    }

    this.$store.commit('setLoading',true)
    this.isLoadingImage = true

    console.log(target.files)
    
    const file = target.files[0]
    this.profileImageNew = file.name
    try{   
      const profileRef = this.$getUserProfileImageRef()

      await uploadBytes(profileRef, file)
      this.profileImageSrc = await this.getImageURL(profileRef)
    }catch(error){
      console.table(error)
      //const errorCode = this.$getErrorCode(error)

      this.notice = {
				message: 'profile.uploadError',
				isShow: true,
				type: {'is-danger': true}
      }


    }finally{
      this.$store.commit('setLoading',false)
      this.isLoadingImage = false
    }
  }

  async getImageURL(r: StorageReference){
    let url = ''
    let data: Blob | null = null
    console.log('start')
    try{
      const thumbsRef = ref(storage,r.fullPath + '_200x200')
      data = await getBlob(thumbsRef)
    }catch(error){
      //console.log(error)
      try{
        data = await getBlob(r)
      }catch(error){
        //console.table(error)
      }
    }finally{
      url = data ? URL.createObjectURL(data) : ''
    }
    return url
  }

}
